/* eslint-disable @next/next/no-img-element */
import { useDeviceType, ConditionalWrapper, Link } from '@packages/shared';
import Image from 'next/image';
import { useConfig } from '@packages/utilities';
import type { LinkBoxItemImageType } from './types';

/**
 * The LinkBoxItemImage component displays the images
 */
export const LinkBoxItemImage = ({
  data: {
    // image
    image_default: imageDefault,
    image_mobile: imageMobile,
    image_tablet: imageTablet,
    // seo
    field_alternate_text: imageAlt,
    field_title: imageTitle,
  },
  link,
}: {
  data: LinkBoxItemImageType;
  link: string;
}) => {
  const { isMobile, isTablet } = useDeviceType();
  const {
    assets: {
      cmsImage: {
        imageOptimizationEnabled,
        uriTransformSource,
        uriTransformEndpoint,
        imageQuality,
      },
    },
  } = useConfig();

  const imageData = (isMobile && imageMobile) || (isTablet && imageTablet) || imageDefault;
  const imageDataWidth = !Array.isArray(imageData?.data) && imageData?.data?.width;
  const imageDataHeight = !Array.isArray(imageData?.data) && imageData?.data?.height;
  const useNextImage = imageData?.url && imageDataWidth && imageDataHeight;

  if (!imageData?.url) {
    return null;
  }

  return (
    <ConditionalWrapper
      condition={link !== ''}
      wrapper={(ch) => (
        <Link href={link} {...(imageTitle && { 'aria-label': imageTitle })} noLinkStyle>
          {ch}
        </Link>
      )}
    >
      {useNextImage ? (
        <Image
          src={
            imageOptimizationEnabled && typeof imageData?.uri === 'string'
              ? imageData.uri.replace(uriTransformSource, uriTransformEndpoint)
              : imageData.url
          }
          alt={imageAlt || ''}
          width={parseInt(imageDataWidth, 10)}
          height={parseInt(imageDataHeight, 10)}
          loading="lazy"
          {...(imageOptimizationEnabled ? { quality: imageQuality } : { unoptimized: true })}
        />
      ) : (
        <img src={imageData?.url} alt={imageAlt || ''} title={imageTitle || ''} loading="lazy" />
      )}
    </ConditionalWrapper>
  );
};
